

import { useAtom } from "jotai";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { userAtom } from "./store";
import apiCall from "./apiCall";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";

// // const routePermissions: Record<string, string[]> = {
// //   "/report/chairman-reports": ["Administrator"],
// // };

// // const ProtectedRoute = () => {
// //   const [user] = useAtom(userAtom);
// //   const location = useLocation();


  
// //   const userRoleNames = user?.RoleNames || [];

// //   const allowedRoles = routePermissions[location.pathname] || [];
// //   const hasAccess =
// //     allowedRoles.length === 0 ||
// //     userRoleNames?.some((role) => allowedRoles.includes(role));

// //   console.log(hasAccess, "hasacc");
// //   if (user?.Token && hasAccess) {
// //     return <Outlet />;
// //   }

// //   return <Navigate to="/overview" replace />;
// // };

// // export default ProtectedRoute;


const ProtectedRoute = () => {
  const [user] = useAtom(userAtom);
  const location = useLocation();
  const navigate=useNavigate()

  useEffect(()=>{
    if(!user){
    navigate('/')
    } 
  },[user])

  const getAllRolePermission = async () => {
    const url = `/MembershipSetUp/member/GetAllRolePermission?actionType=${2}`;
    return await apiCall().get(url);
  };

  const {
    data: rolePermission,
   
  } = useQuery({
    queryKey: ["get-AllRolePermission"],
    queryFn: getAllRolePermission,
    refetchOnWindowFocus: false,
    retry: 0,
    enabled: !!user,
  });

  // Extract role permission data
  const rolePermissionData = rolePermission?.data?.Data || [];
  // const rolePermissionDataError = error as AxiosError;
  // const rolePermissionDataErrorMessage = rolePermissionDataError?.message;

  const routePermissions: Record<string, string[]> = rolePermissionData?.reduce(
    (acc: Record<string, string[]>, item: any) => {
      if (!acc[item?.PathName]) {
        acc[item?.PathName] = [];
      }
      acc[item?.PathName]?.push(item?.RoleName);
      return acc;
    },
    {}
  );

  console.log(routePermissions,'routePermissions')

  const userRoleNames = user?.RoleNames || [];
  const allowedRoles = routePermissions[location.pathname] || [];
  const hasAccess =
    allowedRoles.length === 0 ||
    userRoleNames?.some((role) => allowedRoles.includes(role));


    console.log(hasAccess,'hasAccess')


  // if (isLoading) return <div>Loading...</div>; // Handle loading state
  // if (error) return <div>Error: {rolePermissionDataErrorMessage}</div>; // Handle error state

  if (user?.Token && hasAccess) {
    return <Outlet />;
  }

  return <Navigate to="/overview" replace />;
};

export default ProtectedRoute;
